import { useEffect, useState } from 'react';
import { hasAnyPermissao } from '../auth/entidadeUsuario';
import { Typography, Alert } from "antd";

const { Title, Text, Paragraph } = Typography;

const Home = () => {
  const [verificaAcesso, setVerificaAcesso] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  useEffect(() => {
    if (verificaAcesso === 0) {
      setVerificaAcesso(1);
    }
  }, [verificaAcesso]);

  if (!hasAnyPermissao())
    return (
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "20px" }}>
        <Title level={2} style={{ textAlign: "center" }}>
          Aviso
        </Title>

        <Alert
          message="Uso Restrito"
          description="Este sistema é de uso exclusivo para usuários autorizados."
          type="warning"
          showIcon
          style={{ marginBottom: "20px" }}
        />

        <Paragraph>
          <Text strong>
            Procedimento:</Text>{" "} caso tenha necessidade de acesso a este sistema, procure o gestor de Acessos da sua organização.
        </Paragraph>

        <Paragraph>
          Caso o gestor já tenha lhe dado a autorização, você não deveria estar vendo esta página. Por favor, abra um chamado no Atendimento Ti da Previc (https://atendimentoti.previc.gov.br).
        </Paragraph>

        <Paragraph>
          Atenciosamente,<br />
          Equipe de TI da Previc
        </Paragraph>
      </div>
    );
  else
    return (
      <div
        style={{
          paddingTop: "8rem",
          color: "#205bb9",
        }}
      >

        {/* <div style={{ textAlign: "center" }}>
        <Link to="pessoa-juridica-cadastrar">Pessoa Jurídica - Cadastrar</Link>
        <br />

      </div> */}
      </div>
    );
};

export default Home;
